import { useEffect } from 'react';
import { useFormik } from 'formik';
import { isEmpty } from 'lodash';
import {
  useNowEstablishPageTypeStore,
  useEstablishStore,
  getBtnProps,
  TransitionBtn,
  reloadHandler,
  useIsPrevPageConfirmStore,
} from 'views/components/pages/accountEstablishment/hooks';
import {
  EstablishPageType,
  AccountEstablishRequestParam,
  InvestmentInfoFormikType,
  investmentInfoValidation,
  investmentInfoOnSubmit,
  investmentInfoInitialValues,
  formErrorScroll,
  scrollToTop,
} from 'views/utils/accountEstablish';
import { ButtonProps } from 'views/components/atoms/button';
import { useNavigate } from 'react-router-dom';

export const useInvestmentInfo = () => {
  const navigate = useNavigate();
  const { nowEstablishPageType, setNowEstablishPageType } = useNowEstablishPageTypeStore();
  const { isPrevPageConfirm, setIsPrevPageConfirm } = useIsPrevPageConfirmStore();
  const { param, add } = useEstablishStore();
  const initialValues = investmentInfoInitialValues(param);
  const onSubmit = investmentInfoOnSubmit<AccountEstablishRequestParam>(param, add, () =>
    setNowEstablishPageType(EstablishPageType.RequestConfirm),
  );

  const formik: InvestmentInfoFormikType = useFormik({
    initialValues,
    validationSchema: investmentInfoValidation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  const nextButtonProps: ButtonProps = getBtnProps(TransitionBtn.CONFIRM);
  const prevButtonProps: ButtonProps = getBtnProps(TransitionBtn.PREV, () =>
    setNowEstablishPageType(EstablishPageType.Employment),
  );
  const confirmButtonProps: ButtonProps = getBtnProps(TransitionBtn.CONFIRM);
  useEffect(() => {
    scrollToTop();
    window.addEventListener('beforeunload', reloadHandler);
    return () => {
      window.removeEventListener('beforeunload', reloadHandler);
    };
  }, []);

  useEffect(() => {
    if (nowEstablishPageType === EstablishPageType.CustomerInfo) return;
    navigate(nowEstablishPageType.toString());
  }, [nowEstablishPageType]);

  useEffect(() => {
    if (isEmpty(formik.errors)) return;
    formErrorScroll();
  }, [formik.isSubmitting]);

  return {
    formik,
    buttonProps: {
      nextButtonProps,
      prevButtonProps,
      confirmButtonProps,
      isPrevPageConfirm,
    },
  };
};
